import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getIntegral, getForRecord } from '@/services/http';
import { dateTimeFormatter as _dateTimeFormatter, readCookie } from '@/tools/tools';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import IntegralRule from '@/components/rule/integralRule.vue';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.loading = false; // 加载
    _this.activeIndex = 1; // 默认1：积分记录，2：兑换记录
    _this.listData = []; // 积分记录列表
    _this.forData = []; // 兑换记录列表
    _this.isLoading = false; // 表格加载
    _this.ruleList = []; // 积分规则列表
    _this.totalnumber = 0; // 总条数
    _this.pageNo = 1; // 当前页
    _this.pageSize = 10; // 当前条数
    _this.showRule = false; // 是否显示规则说明
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getListData(); // 获取列表数据
    }
    // 积分记录、兑换记录切换
  }, {
    key: "changeActiveIndex",
    value: function changeActiveIndex(index) {
      this.activeIndex = index;
      this.pageNo = 1;
      this.pageSize = index === 1 ? 10 : 5;
      this.getListData();
    }
    // 获取列表数据
  }, {
    key: "getListData",
    value: function () {
      var _getListData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              anchor = readCookie('anchor');
              this.listData = [];
              res = {};
              if (!(this.activeIndex === 1)) {
                _context.next = 10;
                break;
              }
              _context.next = 6;
              return getIntegral({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1
              });
            case 6:
              res = _context.sent;
              if (res.data.code === 100) {
                this.listData = res.data.data.list;
                this.totalnumber = res.data.data.total;
              } else {
                this.$message.error(res.data.message);
              }
              _context.next = 15;
              break;
            case 10:
              if (!(this.activeIndex === 2)) {
                _context.next = 15;
                break;
              }
              _context.next = 13;
              return getForRecord({
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                src: anchor ? anchor.src ? anchor.src : 2 : 4
              });
            case 13:
              res = _context.sent;
              if (res.data.code === 100) {
                this.forData = res.data.data.list;
                this.totalnumber = res.data.data.total;
              } else {
                this.$message.error(res.data.message);
              }
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getListData() {
        return _getListData.apply(this, arguments);
      }
      return getListData;
    }() // 条数回调
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getListData();
    }
    // 页数回调
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getListData();
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    NavMenu: NavMenu,
    IntegralRule: IntegralRule
  },
  filters: {
    dateTimeFormatter: function dateTimeFormatter(value) {
      return _dateTimeFormatter(value);
    }
  }
})], default_1);
export default default_1;